import { isExperimentSatisfied } from '@routes/utils/isExperimentSatisfied'
import { GetRouterMethodArgs, RouterMethod } from '@routes/utils/types'

/**
 * Determines the router method (push or replace) to be used for navigating to a route
 */
export function getRouterMethod({ currentRoute, nextRoute, isContainerApp }: GetRouterMethodArgs): RouterMethod {
    if (nextRoute.definition.customRouterMethod) {
        const method = nextRoute.definition.customRouterMethod({
            currentRoute,
            nextRoute,
            isContainerApp,
        })

        if (method) {
            return method
        }
    }

    if (!isExperimentSatisfied(nextRoute)) {
        return 'full-page-load'
    }

    // Use case: navigating to the same path (maybe the query params changed)
    if (currentRoute.hasSameDefinition(nextRoute)) {
        return 'replace'
    }

    if (!isContainerApp) {
        return 'push'
    }

    const areBothPagesWithoutNavigation =
        currentRoute.definition.disableMobileNav && nextRoute.definition.disableMobileNav

    if (areBothPagesWithoutNavigation) {
        // When we turn off the nav, something else (i.e. the Messenger) is handling things like backward navigation for us
        return 'replace'
    }

    const prevHasMobileNavBar = Boolean(currentRoute.definition.mobileNavTitle)
    const prevHasNoNav = Boolean(currentRoute.definition.mobileNavTitle)

    // Coming from a page without the main navigation
    if (prevHasMobileNavBar || prevHasNoNav) {
        // Use case: navigating between two pages in the same set of tabs
        if (currentRoute.definition.tabset && currentRoute.definition.tabset === nextRoute.definition.tabset) {
            return 'replace'
        }

        const nextHasMobileNavBar = Boolean(nextRoute.definition.mobileNavTitle)

        // Use case: navigating between two pages that both have the mobile nav bar
        if (prevHasMobileNavBar && nextHasMobileNavBar) {
            return 'replace'
        }
    }

    // Use case: navigating between two pages in the same set of tabs
    if (currentRoute.definition.tabset && currentRoute.definition.tabset === nextRoute.definition.tabset) {
        return 'replace'
    }

    return 'push'
}
